import React, { ChangeEvent } from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";

import { V1, V2 } from "../../Api";
import { formatName, formatPhone } from "../../Utilities";
import ToolbarMenuItem from "../ToolbarMenuItem";
import ViewToolbar from "../ViewToolbar";

import withTitle from "../withTitle";

interface IMessagingNumberManagementViewState {
    isNumbersLoading: boolean | string;
    isSaving: boolean | string;
    numbers: any[];
    number: any;
    assignments: any[];

    employees: any[];
    locations: any[];

    newAssignmentType: "" | "person" | "location";
    newAssignmentId: string;
    newAssignmentPreferred: boolean;
    numberName: string;
}

interface IMessagingNumberManagementViewProps extends RouteComponentProps<any> {

}

class MessagingNumberManagementView extends React.Component<IMessagingNumberManagementViewProps, IMessagingNumberManagementViewState> {
    constructor(props: Readonly<IMessagingNumberManagementViewProps>) {
        super(props);

        const state: IMessagingNumberManagementViewState = {
            isNumbersLoading: true,
            isSaving: false,
            numbers: [],
            number: {},
            assignments: [],

            employees: [],
            locations: [],

            newAssignmentType: "",
            newAssignmentId: "",
            newAssignmentPreferred: false,
            numberName: "",
        };

        this.state = state;

        this.formInputChanged = this.formInputChanged.bind(this);
        this.addAssignment = this.addAssignment.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
    }

    public componentDidMount() {
        if (this.props.match.params.id) {
            this.loadNumberDetails();
        }
        else {
            this.loadNumbers();
        }

        this.loadAuxInfo();
    }

    public componentDidUpdate(prevProps: Readonly<IMessagingNumberManagementViewProps>) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            if (this.props.match.params.id) {
                this.loadNumberDetails();
            }
            else {
                this.loadNumbers();
            }
        }
    }

    public render() {
        if (this.props.match.params.id) {
            return this.renderDetails();
        }
        else {
            return this.renderList();
        }
    }

    private renderList() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <ToolbarMenuItem>
                        <Link to="/reminders/numbers/add" className="icon-plus" title="Add number..." />
                    </ToolbarMenuItem>
                </ViewToolbar>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Number</th>
                            <th>Locations</th>
                            <th>People</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.isNumbersLoading === true
                            ? <tr>
                                <td colSpan={10}>
                                    <div className="spinner spinner-center lds-dual-ring" />
                                </td>
                            </tr>
                            : typeof this.state.isNumbersLoading === "string"
                                ? <tr>
                                    <td colSpan={10} className="error-text">{this.state.isNumbersLoading}</td>
                                </tr>
                                : this.state.numbers.length === 0
                                    ? <tr>
                                        <td colSpan={10} className="error-text">No numbers found.</td>
                                    </tr>
                                    : this.state.numbers.map(a => <tr key={a.id} className="clickable" onClick={() => this.goNumber(a.id)}>
                                        <td>{a.name}</td>
                                        <td>{formatPhone(a.number)}</td>
                                        <td>{a.locations.length > 0 ? a.locations.map((b: any) => b.shortName || b.name).join(", ") : "-"}</td>
                                        <td>{a.employeeCount || 0}</td>
                                    </tr>)
                        }
                    </tbody>
                </table>

            </div>
        );
    }

    private renderDetails() {
        return (
            <div className="viewer-root input-form">
                <div className="column-root">
                    <section className="info-block">
                        <header>
                            <h3>Number Info</h3>
                        </header>

                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-number">Number</label>
                                <input type="text" id="frm-number" defaultValue={this.state.number.number || ""} readOnly={true} />
                            </div>
                            <div className="input-form-group">
                                <label htmlFor="frm-number-name">Name</label>
                                <input type="text" id="frm-number-name" name="numberName" value={this.state.numberName} onChange={this.formInputChanged} />
                            </div>
                        </section>
                    </section>
                    <section />
                </div>

                <h3>Assignments</h3>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="col-smallest">Type</th>
                            <th className="col-smallest">Pref.</th>
                            <th>Name</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.isNumbersLoading === true
                            ? <tr>
                                <td colSpan={10}>
                                    <div className="spinner spinner-center lds-dual-ring" />
                                </td>
                            </tr>
                            : typeof this.state.isNumbersLoading === "string"
                                ? <tr>
                                    <td colSpan={10} className="error-text">{this.state.isNumbersLoading}</td>
                                </tr>
                                : this.state.assignments.map(a => <tr key={a.id} className={a.isDeleted ? "row-strike-text row-gray-text" : a.isNew ? "row-ltblue" : undefined}>
                                    <td>{a.employee ? "Person" : "Office"}</td>
                                    <td className="col-center">{a.isPreferred ? <i className="icon-check" title="User's preferred number" /> : null}</td>
                                    <td>{a.employee
                                        ? formatName(a.employee.name)
                                        : (a.location.shortName || a.location.name)}
                                    </td>
                                    <td>
                                        {!a.isDeleted
                                            ? <button type="button" className="bare red icon-times" onClick={() => this.removeAssignment(a.id)} title="Delete" />
                                            : <button type="button" className="bare icon-repeat" onClick={() => this.readdAssignment(a.id)} title="Undo. Re-add" />}
                                    </td>
                                </tr>)}
                        <tr>
                            <td className="col-nopad">
                                <select name="newAssignmentType" value={this.state.newAssignmentType} onChange={this.formInputChanged}>
                                    <option></option>
                                    <option value="person">Person</option>
                                    <option value="location">Office</option>
                                </select>
                            </td>
                            <td>
                                <input type="checkbox" name="newAssignmentPreferred" checked={this.state.newAssignmentPreferred} onChange={this.formInputChanged} />
                            </td>
                            <td className="col-nopad">
                                <select name="newAssignmentId" value={this.state.newAssignmentId} onChange={this.formInputChanged}>
                                    <option></option>
                                    {this.state.newAssignmentType === "person"
                                        ? this.state.employees.map(a => <option key={a.id} value={a.id} disabled={this.state.assignments.some(b => b.employee?.id === a.id)}>
                                            {formatName(a.name)}
                                        </option>)
                                        : this.state.newAssignmentType === "location"
                                            ? this.state.locations.map(a => <option key={a.id} value={a.id} disabled={this.state.assignments.some(b => b.location?.id === a.id)}>
                                                {a.shortName || a.name}
                                            </option>)
                                            : null}
                                </select>
                            </td>
                            <td className="col-nopad">
                                <button type="button" className="button btn-light small icon-plus" onClick={this.addAssignment} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                &nbsp;
                {this.state.isSaving === true
                    ? <div className="spinner lds-dual-ring" />
                    : typeof this.state.isSaving === "string"
                        ? <div className="error-text">{this.state.isSaving}</div>
                        : null}
                <div className="action-panel-dialog">
                    <span className="spring" />
                    <button type="submit" className="button text-with-icon" onClick={this.saveChanges}><i className="icon-check" /><span>Save</span></button>
                </div>
            </div>
        );
    }

    private formInputChanged(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) {
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            [name]: value
        } as any);
    }


    private async loadAuxInfo() {
        try {
            var [employees, locations] = await Promise.all([
                V1.get<any[]>("employees/summary?limit=1000"),
                V2.get<any[]>("locations?type=office"),
            ]);

            employees.sort((a, b) => formatName(a.name).localeCompare(formatName(b.name)));
            locations.sort((a, b) => (a.shortName || a.name).localeCompare(b.shortName || b.name));

            this.setState({
                employees,
                locations
            });
        }
        catch (e) {
            // TODO: What should we do with this if it errors?
        }
    }

    private async loadNumbers() {
        try {
            this.setState({
                isNumbersLoading: true
            });

            var result = await V2.get<any>("messaging/numbers");

            this.setState({
                isNumbersLoading: false,
                numbers: result.numbers
            });
        }
        catch (e) {
            this.setState({
                isNumbersLoading: e.message || "Could not load numbers"
            });
        }
    }

    private async loadNumberDetails() {
        try {
            this.setState({
                isNumbersLoading: true,

                numberName: "",
                number: {},
                newAssignmentType: "",
                newAssignmentId: ""
            });

            var [number, assignmentResult] = await Promise.all([
                V2.get<any>(`messaging/numbers/${this.props.match.params.id}`),
                V2.get<any>(`messaging/numbers/${this.props.match.params.id}/assignments`),
            ]);

            this.setState({
                isNumbersLoading: false,
                number,
                numberName: number.name,
                assignments: assignmentResult.assignments
            });
        }
        catch (e) {
            this.setState({
                isNumbersLoading: e.message || "Could not load numbers"
            });
        }
    }

    private goNumber(id: string) {
        this.props.history.push(`/reminders/numbers/${id}`);
    }

    private addAssignment() {
        const assignments = this.state.assignments;

        switch (this.state.newAssignmentType) {
            case "person":
                assignments.push({
                    isNew: true,
                    id: Date.now().toString(),
                    employee: this.state.employees.find(a => a.id === this.state.newAssignmentId),
                    isPreferred: this.state.newAssignmentPreferred
                });
                break;
            case "location":
                assignments.push({
                    isNew: true,
                    id: Date.now().toString(),
                    location: this.state.locations.find(a => a.id === this.state.newAssignmentId),
                    isPreferred: false,
                });
                break;
        }

        this.setState({
            assignments,
            newAssignmentType: "",
            newAssignmentId: "",
            newAssignmentPreferred: false,
        });
    }

    private removeAssignment(id: string) {
        const assignments = this.state.assignments;
        const assignment = assignments.find(a => a.id === id);
        if (!assignment) {
            return;
        }

        assignment.isDeleted = true;

        this.setState({
            assignments
        });
    }

    private readdAssignment(id: string) {
        const assignments = this.state.assignments;
        const assignment = assignments.find(a => a.id === id);
        if (!assignment) {
            return;
        }

        assignment.isDeleted = false;

        this.setState({
            assignments
        });
    }

    private async saveChanges() {
        try {
            this.setState({
                isSaving: true
            });

            const additions = this.state.assignments
                .filter(a => a.isNew && !a.isDeleted)
                .map(a => ({
                    employeeId: a.employee?.id,
                    locationId: a.location?.id,
                    isPreferred: a.isPreferred
                }));
            const removals = this.state.assignments
                .filter(a => a.isDeleted && !a.isNew)
                .map(a => ({
                    id: a.id
                }));

            const data = {
                addAssignments: additions,
                removeAssignments: removals
            } as any;

            if (this.state.numberName !== this.state.number.name) {
                data.name = this.state.numberName;
            }

            await V2.patch(`messaging/numbers/${this.props.match.params.id}`, data);

            this.setState({
                isSaving: false
            });

            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                isSaving: e.message || "Could not save changes"
            });
        }
    }
}

export default withTitle("Phone Number Management", MessagingNumberManagementView);